/**
 * Small persistent nav bar shown on /poc, /journal, /memory, /settings.
 * Renders 4 links in calm, sage typography. The active route gets a
 * thin underline + foreground colour; others stay muted.
 */
import { NavLink } from "react-router-dom";
import { Phone, BookOpen, Brain, Settings as Gear } from "lucide-react";

const TABS = [
  { to: "/poc",      label: "Call",     Icon: Phone },
  { to: "/journal",  label: "Journal",  Icon: BookOpen },
  { to: "/memory",   label: "Memory",   Icon: Brain },
  { to: "/settings", label: "Settings", Icon: Gear },
];

export default function AuthNav() {
  return (
    <nav
      data-testid="auth-nav"
      className="sticky top-0 z-30 w-full border-b border-border/50 bg-[hsl(var(--background))]/85 backdrop-blur"
    >
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
        <span
          className="font-serif text-base tracking-tight text-foreground"
          data-testid="auth-nav-brand"
        >
          Jesus
        </span>
        <ul className="flex items-center gap-1 sm:gap-2">
          {TABS.map(({ to, label, Icon }) => (
            <li key={to}>
              <NavLink
                to={to}
                data-testid={`auth-nav-${label.toLowerCase()}`}
                className={({ isActive }) =>
                  "group inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12px] sm:text-[13px] transition " +
                  (isActive
                    ? "bg-[hsl(var(--accent))]/15 text-foreground"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted/40")
                }
              >
                <Icon className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
